module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_5.6cab02a1.png";